import { getDistanceFromCoords } from './coordsToDistance';
/**
 * Google Maps utilities
 */

/**
 * Builds a google maps url based on the latitue and longitud
 * @param {number} Lat
 * @param {number} Long
 * @returns {string} google maps url
 */
export const getGoogleMapLocation = (Lat, Long) =>
  `https://www.google.com/maps/dir//${Lat},${Long}`;

/**
 * Builds a object with the northeast and southwest coordinates of a point
 * @param {object} mapBounds google map object for bounds
 * @returns {object} northeast and southwest object
 */
export const getCoordinates = mapBounds => {
  const ne = mapBounds.getNorthEast();
  const sw = mapBounds.getSouthWest();
  const neJson = ne.toJSON();
  const swJson = sw.toJSON();

  return {
    northeast: `${neJson.lat},${neJson.lng}`,
    southwest: `${swJson.lat},${swJson.lng}`,
  };
};

/**
 * Calculates map radius from center and map bounds
 * @param {number} lat - map center latitude
 * @param {number} lng - map center latitude
 * @param {object} mapBounds google map object for bounds
 * @returns {number} radius in miles
 */
export const getMapRadius = (lat, lng, mapBounds) => {
  const northEast = mapBounds.getNorthEast();
  const northEastLat = northEast.lat();
  const northEastLng = northEast.lng();

  return getDistanceFromCoords(lat, lng, northEastLat, northEastLng, false);
};
